/** @ignore *//** */
const config = {
  version: '2.12.1',
  type: 'js'
};

export default config;


// WEBPACK FOOTER //
// ./src/config.ts